module.exports = __webpack_public_path__ + "img/BYOCS_Icons_SDOH_Social_noBG.384e5121.png";